if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            const modal = this.closest('[data-one-time-purchase-modal]');
            if (modal) {
              modal.removeAttribute('open');
              document.body.classList.remove('overflow-hidden');
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
document.addEventListener("DOMContentLoaded", function() {
  // Function to add event listeners to the PDP buttons
  function addClickListeners() {
      const productLinks = document.querySelectorAll('.variant-type-link');
      // Check if there are any product links before proceeding
      if (productLinks.length === 0) return;
      productLinks.forEach(function(link) {
          link.addEventListener('click', function(event) {
              event.preventDefault();
              const url = this.getAttribute('data-url');
              // Update the browser's URL without reloading the page
              window.history.replaceState(null, '', url);
              fetch(url)
                .then(response => response.text())
                .then(html => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');
                    const newContent = doc.querySelector('.product-page-template');
                    const productMediaModal = doc.querySelector('.product-media-modal');                    
                    const productModal = document.querySelectorAll('product-modal,quick-add-modal,product-modal-dialog');
                    productModal.forEach(function(element) {
                        element.remove();
                    });
                    if (newContent) {
                        const pageTemplate = document.querySelector('.product-page-template');
                        if (pageTemplate) {
                            pageTemplate.innerHTML = newContent.innerHTML;
                        }
                        // Only update product media modal if it exists in the new content and on the current page
                        if (productMediaModal) {
                            const mediaModal = document.querySelector('.product-media-modal');
                            if (mediaModal) {
                                mediaModal.innerHTML = productMediaModal.innerHTML;
                            }
                        }
                        // Reload Trustpilot widget if it exists
                        const trustbox = document.querySelectorAll('.trustpilot-widget');
                        if (trustbox.length > 0) {
                            trustbox.forEach(function(element) {
                                window.Trustpilot.loadFromElement(element);
                            });
                        }
                        addClickListeners();
                    } else {
                        console.error('New content not found.');
                    }
                })
                .catch(error => {
                  console.error('Error loading new content:', error);
                  // Redirect to the specified URL if fetch fails
                  window.location.href = url;
                });                
          });
      });
  }
  addClickListeners();
});
